import { EventEmitter } from './eventEmitter';
import { Events } from './types';

export const emitter = new EventEmitter<Events>();
export type { ImageGenerativeTaskEvent } from './types';
export { EventsEnum } from './types';
